export const flattenClientBonusInstance = bonus => {
  if (!bonus?.bonus || typeof bonus.bonus !== 'object') {
    return bonus;
  }

  return {
    ...bonus,
    ...bonus.bonus,
    id: bonus.id,
  };
};

export const getEffectiveTimeToWager = bonus =>
  bonus?.timeToWager ?? bonus?.copiedBonusSettings?.timeToWager;
